<template>
    <section class="team"  v-if="loaded && ready" >


      <div class="container" :class="{'vis' :  offSet.last >= offsetIndex}"   v-if="!isMobile">

        <div class="grid-people"  id="grid-people2" :class="{'hide' : vis}"   v-if="partners">
          <div class="btn-res" v-if="vis" v-on:click="resetVis()"></div>
          <div class="grid-people-row1">
            <div class="people-item people-item0" :class="{'active' : (itemActive === 0 && ballOpen === 'open') }"    v-on:mouseover="controlDragTool(1, 0)" v-on:mouseout="controlDragTool(6)" v-on:click="clickItem( $event, 0)"> <img :src="partData[0].img" :alt="partData[0].name">
              <div class="content-item">
                <div  v-if="itemActive != 99" >
                  <h2>{{partData[itemActive].name}}, {{partData[itemActive].func[lang].name}}</h2>
                  <p v-html="partData[itemActive].text[lang].name"></p>
                </div>
              </div>
              <div class="partner-name">
                <p>
                  <strong>{{partData[0].name}}</strong>
                  <span>{{partData[0].func[lang].name}}</span>
                </p>

              </div>
            </div>
            <div class="people-item people-item1" :class="{'active' : (itemActive === 1 && ballOpen === 'open') }"   v-on:mouseover="controlDragTool(1, 1)" v-on:mouseout="controlDragTool(6)"   v-on:click="clickItem($event,1)"><img :src="partData[1].img" :alt="partData[1].name">
              <div class="content-item">
                <div  v-if="itemActive != 99" >
                  <h2>{{partData[itemActive].name}}, {{partData[itemActive].func[lang].name}}</h2>
                  <p v-html="partData[itemActive].text[lang].name"></p>
                </div>
              </div>
              <div class="partner-name">
                <p>
                  <strong>{{partData[1].name}}</strong>
                  <span>{{partData[1].func[lang].name}}</span>
                </p>

              </div>
            </div>
            <div class="people-item people-item2" :class="{'active' : (itemActive === 2 && ballOpen === 'open') }"   v-on:mouseover="controlDragTool(1, 2)" v-on:mouseout="controlDragTool(6)"   v-on:click="clickItem($event,2)"> <img :src="partData[2].img" :alt="partData[2].name">
              <div class="content-item">
                <div  v-if="itemActive != 99" >
                  <h2>{{partData[itemActive].name}}, {{partData[itemActive].func[lang].name}}</h2>
                  <p v-html="partData[itemActive].text[lang].name"></p>
                </div>
              </div>
              <div class="partner-name">
                <p>
                  <strong>{{partData[2].name}}</strong>
                  <span>{{partData[2].func[lang].name}}</span>
                </p>

              </div>
            </div>

          </div>
        </div>
        <div class="grid-people"  id="grid-people" :class="{'hide' : vis}"   v-if="!partners">
          <div class="btn-res" v-if="vis" v-on:click="resetVis()"></div>
          <div class="grid-people-row1">
            <div class="people-item people-item0" :class="{'active' : (itemActive === 0 && ballOpen === 'open') }"  v-on:mouseover="controlDragTool(1, 0)" v-on:mouseout="controlDragTool(6)"  v-on:click="clickItem( $event, 0)"> <img :src="newArr[0].img" :alt="newArr[0].name">
             <div class="content-item">
               <div  v-if="itemActive != 99" >
                 <h2>{{newArr[itemActive].name}}, {{newArr[itemActive].func[lang].name}}</h2>
                 <p v-html="newArr[itemActive].text[lang].name"></p>
               </div>
             </div>
            </div>
            <div class="people-item people-item1" :class="{'active' : (itemActive === 1 && ballOpen === 'open') }"   v-on:mouseover="controlDragTool(1, 1)" v-on:mouseout="controlDragTool(6)"  v-on:click="clickItem($event,1)"><img :src="newArr[1].img" :alt="newArr[1].name">
              <div class="content-item">
                <div  v-if="itemActive != 99" >
                  <h2>{{newArr[itemActive].name}}, {{newArr[itemActive].func[lang].name}}</h2>
                  <p v-html="newArr[itemActive].text[lang].name"></p>
                </div>
              </div>
            </div>
            <div class="people-item people-item2" :class="{'active' : (itemActive === 2 && ballOpen === 'open') }"  v-on:mouseover="controlDragTool(1, 2)" v-on:mouseout="controlDragTool(6)"  v-on:click="clickItem($event,2)"> <img :src="newArr[2].img" :alt="newArr[2].name">
              <div class="content-item">
                <div  v-if="itemActive != 99" >
                  <h2>{{newArr[itemActive].name}}, {{newArr[itemActive].func[lang].name}}</h2>
                  <p v-html="newArr[itemActive].text[lang].name"></p>
                </div>
              </div>
            </div>
            <div   class="people-item people-item3" :class="{'active' : (itemActive === 3 && ballOpen === 'open') }"   v-on:mouseover="controlDragTool(1, 3)" v-on:mouseout="controlDragTool(6)"  v-on:click="clickItem($event,3)"> <img :src="newArr[3].img" :alt="newArr[3].name">
              <div class="content-item">
                <div  v-if="itemActive != 99" >
                  <h2>{{newArr[itemActive].name}}, {{newArr[itemActive].func[lang].name}}</h2>
                  <p v-html="newArr[itemActive].text[lang].name"></p>
                </div>
              </div>
            </div>

          </div>
          <div class="grid-people-row2" v-if="!partners">

            <div class="grid-people-col-master">

              <div class="grid-people-col-master-box" v-if="lang == 0">
                <div>60 <span>+</span></div>
                <div>perspetivas <br> <span>únicas</span></div>
                <div class="shuffle" v-on:click="shuffleMore()"> <span>+</span>Ver mais pessoas</div>
              </div>
              <div class="grid-people-col-master-box" v-if="lang == 1">
                <div>60 <span>+</span></div>
                <div>unique <br> <span>prespectives</span></div>
                <div class="shuffle" v-on:click="shuffleMore()"> <span>+</span>Shuffle more people</div>
              </div>

            </div>

            <div class="grid-people-col-cards">

              <div class="grid-people-row1">
                <div class="people-item people-item4"  :class="{'active' : (itemActive === 4 && ballOpen === 'open') }"  v-on:mouseover="controlDragTool(1, 4)" v-on:mouseout="controlDragTool(6)" v-on:click="clickItem($event,4)"><img :src="newArr[4].img" :alt="newArr[4].name">
                  <div class="content-item">
                    <div  v-if="itemActive != 99" >
                      <h2>{{newArr[itemActive].name}}, {{newArr[itemActive].func[lang].name}}</h2>
                      <p v-html="newArr[itemActive].text[lang].name"></p>
                    </div>
                  </div>
                </div>
                <div class="people-item people-item5"  :class="{'active' : (itemActive === 5 && ballOpen === 'open') }"  v-on:mouseover="controlDragTool(1, 5)" v-on:mouseout="controlDragTool(6)" v-on:click="clickItem($event,5)"><img :src="newArr[5].img" :alt="newArr[5].name">
                  <div class="content-item">
                    <div  v-if="itemActive != 99" >
                      <h2>{{newArr[itemActive].name}}, {{newArr[itemActive].func[lang].name}}</h2>
                      <p v-html="newArr[itemActive].text[lang].name"></p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="grid-people-row1">
                <div class="people-item people-item6"  :class="{'active' : (itemActive === 6 && ballOpen === 'open') }"  v-on:mouseover="controlDragTool(1, 6)" v-on:mouseout="controlDragTool(6)" v-on:click="clickItem($event,6)"><img :src="newArr[6].img" :alt="newArr[6].name">
                  <div class="content-item">
                    <div  v-if="itemActive != 99" >
                      <h2>{{newArr[itemActive].name}}, {{newArr[itemActive].func[lang].name}}</h2>
                      <p v-html="newArr[itemActive].text[lang].name"></p>
                    </div>
                  </div>
                </div>
                <div class="people-item people-item7"  :class="{'active' : (itemActive === 7 && ballOpen === 'open') }"  v-on:mouseover="controlDragTool(1, 7)" v-on:mouseout="controlDragTool(6)" v-on:click="clickItem($event,7)"><img :src="newArr[7].img" :alt="newArr[7].name">
                  <div class="content-item">
                    <div  v-if="itemActive != 99" >
                      <h2>{{newArr[itemActive].name}}, {{newArr[itemActive].func[lang].name}}</h2>
                      <p v-html="newArr[itemActive].text[lang].name"></p>
                    </div>
                  </div>
                </div>
              </div>
              </div>
            </div>










        </div>





        </div>

      <div class="container" :class="{'vis' :  offSet.last >= offsetIndex}"   v-if="isMobile && !partners">


        <div class="mobile-people-header">
          <div>60 <span>+</span></div>
          <div>perspectivas <br> <span>únicas</span></div>
          <div class="shuffle" v-on:click="shuffleMore()"> <span>+</span>ver mais pessoas</div>
        </div>


        <div class="people-item" v-for="(item, index) in newArr"  v-on:click="clickItem(0)"> <img :src="newArr[0].img" :alt="newArr[0].name"> </div>




      </div>
      <div class="ball-cont" :class="[dragToolOff, dragToolOffT, ballOpen]"  v-on:click="resetVis()"  v-if="!isMobile && !partners">

        <div  class="ball-cont-box">
          <div v-if="itemActive != 99" class="ball-cont-box2">
            <div class="ball-cont-func">  {{newArr[itemActive].func[lang].name}} </div>
            <div class="ball-cont-name">  {{newArr[itemActive].name}}  </div>
            <!--div class="ball-cont-quote">  {{newArr[itemActive].quote}}  </div-->
          </div>
        </div>

        <!--

        <div  class="ball-text" :class="[dragToolOff, dragToolOffT, {'hide' : !vis},  chars ]">
          <p v-if="itemActive != 99" v-html="newArr[itemActive].text[lang].name"></p>
        </div>

        -->


      </div>


      <div id="dragme"  class="dragme" :class="{'ver' : dragToolMode == 1 && !vis, 'hide' : dragToolMode == 6 || vis}" v-if="!partners">

        <span class="" >  CLICK    </span>

      </div>
      <div id="dragme2"  class="dragme" :class="{'ver' : dragToolMode == 1 && !vis, 'hide' : dragToolMode == 6 || vis}" v-if="partners">

        <span class="" >  CLICK    </span>

      </div>

      <div class="force-preloader-team" v-if="preloaderTeam" style="display:none;">

        <img v-for="(item, index) in teamDataMaster" :src="item.img" :alt="item.name" >
      </div>
      <!--div  v-if="itemActive != 99" class="ball-text-aux">{{newArr[itemActive].text[lang].name}}</div-->
    </section>
</template>

<script>




    import {TweenMax} from "gsap/TweenMax";
    import {EVENTBUS, PROJ, WP} from '../../main';
    import MediaType from "./MediaType";




   // import Masonry from "masonry-layout/masonry";



    export default {


        name: 'team',
      components: { MediaType},
      props: ['actRoute', 'offSet', 'lang', 'isMobile', 'partners', 'offsetIndex'],
        data() {
            return {
              loaded: false,
              ready: false,
              teamData: [],
              partData: [],

              pastArr: [],
              newArr: [],
              num: 8,
              dragToolMode: 6,
              dragToolOff: 'hide',
              dragToolOffT: '',
              itemActive: 99,
              el :{},
              el2 :{},
              vis: false,
              _x:0,_y:0,
              inSuff:1,
              chars: 'boda',
              ballOpen: '',

              preloaderTeam: false,
              teamDataMaster: [],

            }
        },

      created() {
        const _this = this;

        //alert(this.$route.path.substring(9, this.$route.path.length))

        WP('team', function (response){
          _this.teamDataMaster = response;
          _this.loaded = true;

          setTimeout(function() {
            _this.preloaderTeam = true;
            setTimeout(function() {
             // _this.preloaderTeam = false;
            }, 10000);
          }, 2000);
          let tmp = [];


          for(let i = 0; i < response.length; i++){

           // console.log(response[i].name)

            if(_this.partners) {

              if(response[i].partner){
                tmp.push(response[i])
              }

            }else{
              if(!response[i].partner){
                tmp.push(response[i])
              }

            }

          }


          if(_this.partners) {
            _this.partData =  tmp;
          }else{
            _this.teamData =  _this.getShuffledArr(tmp);
          }

        //  console.log(_this.teamData)

          _this.init();

        });

      },
      mounted() {
        const _this = this;
        _this.ready = true;
        _this.init();

        EVENTBUS.$on('resetTeam', this.resetVis);

      },

      destroyed() {

      },

      methods: {





        init() {
          const _this = this;

          if(this.loaded && this.ready){

            setTimeout(function() {



              if(!_this.partners){
                _this.el = document.getElementById('grid-people');
                _this.el.addEventListener( "mousemove",  _this.navigationDrag2, false );
                _this.el.addEventListener( "touchmove",  _this.touchDrag2, false );
              }

              if(_this.partners){
                _this.el2 = document.getElementById('grid-people2');
                _this.el2.addEventListener( "mousemove",  _this.navigationDrag3, false );
                _this.el2.addEventListener( "touchmove",  _this.touchDrag3, false );
              }


              // _this.el2 = document.getElementById('grid-people2');


           //   _this.el2.addEventListener( "mousemove",  _this.navigationDrag3, false );
             // _this.el2.addEventListener( "touchmove",  _this.touchDrag3, false );

            }, 200);


              _this.changeArr();




          }
        },





        shuffleMore(){
          const _this = this;

          if(_this.inSuff === 1) {
            _this.suffLoop();
          }



        },

        suffLoop(){
          const _this = this;
          setTimeout(function() {




            if(_this.inSuff < 20) {
              _this.suffLoop();
              _this.changeArr();

              _this.inSuff ++;
            }else{
              _this.inSuff = 1;
            }

            //  console.log(_this.newArr);
          }, (10 * _this.inSuff));

        },




        resetVis(){
          this.vis = false;
          this.itemActive = 99;
          this.dragToolMode = 6;
          this.dragToolOff = 'hide';
          this.ballOpen = '';


        },


        controlDragTool(n, off = 99){




          if(!this.vis   && this.inSuff === 1)  {
            this.dragToolMode = n;

            let _offL = '';

            if(off === 0) {
              _offL = 'left1';
            }
            else if(off === 1 ){
              _offL = 'left2';
            }
            else if(off === 2 || off === 4 || off === 6){
              _offL = 'right2';
            }
            else if(off === 3 || off === 5 || off === 7){
              _offL = 'right1';
            }
            else if(off === 99){
              _offL = 'hide';
            }


            this.dragToolOff =  _offL;
            this.itemActive = off;
          }

          this.evtRepose();
        },

        evtRepose(){

          const _this = this;

          //let _offParent = $('.grid-people').offset();
          //let _off = $('#dragme').offset();
          let boda = _this._y +  $( window ).scrollTop();
          TweenMax.to( '.ball-cont', .03, { x:   _this._x, y: boda, force3D: true, ease: Power2.easeOut} );



          setTimeout(function() {

            if(_this.dragToolMode == 1 && !_this.vis){
              _this.evtRepose();
            }

          }, 30);
        },

        touchDrag2(e){
          this.navigationDrag2(e.touches[0]);
        },
        navigationDrag2(e) {

           this._x =  e.clientX
          this._y =  e.clientY
         // let _offParent = $('.grid-people').offset();
          //let _off = $('#dragme').offset();

          if(!this.vis) {
            TweenMax.to( '#dragme', .03, { x:   this._x, y: this._y , force3D: true, ease: Power2.easeOut} );
            // TweenMax.to( '.ball-cont', .03, { x:   _x, y: (_off.top -  _offParent.top), force3D: true, ease: Power2.easeOut} );
           //TweenMax.to( '.ball-cont', .03, {delay: 0.2,  x:   _x, y: (_off.top -  _offParent.top), force3D: true, ease: Power2.easeOut} );


            if(this._y > (window.innerHeight / 2)){
              this.dragToolOffT = 'bottom';
            }else{
              this.dragToolOffT = 'top';
            }
          }
  // dragToolOffT


        },



        touchDrag3(e){
          this.navigationDrag3(e.touches[0]);
        },
        navigationDrag3(e) {

          this._x =  e.clientX
          this._y =  e.clientY
          // let _offParent = $('.grid-people').offset();
          //let _off = $('#dragme').offset();

          if(!this.vis) {
            TweenMax.to( '#dragme2', .03, { x:   this._x, y: this._y , force3D: true, ease: Power2.easeOut} );
            // TweenMax.to( '.ball-cont', .03, { x:   _x, y: (_off.top -  _offParent.top), force3D: true, ease: Power2.easeOut} );
            //TweenMax.to( '.ball-cont', .03, {delay: 0.2,  x:   _x, y: (_off.top -  _offParent.top), force3D: true, ease: Power2.easeOut} );


          }
          // dragToolOffT


        },



        isActive(n) {
          let hasFilter = false;
          for(let i  = 0; i < this.activeFilters.length; i++){
            if(this.activeFilters[i] == n){
              hasFilter = true;

            }
          }

          return hasFilter;
        },




        changeArr(){

          const _this = this;
          if(_this.pastArr.length === 0){
            for(let i = 0; i < _this.teamData.length; i ++) {
              if(i < _this.num) {
                _this.newArr.push(_this.teamData[i]);
              }
            }
          }else{
            _this.newArr = [];
            do{
              let it = _this.getItemArr();
              if(_this.existsPast(it)){
                _this.newArr.push(it);
              }
            }while (_this.newArr.length < _this.num);
            _this.pastArr = [];
          }
          _this.pastArr  = _this.newArr;


         console.log( _this.newArr)

          setTimeout(function() {
            //_this.changeArr();
          }, 4000);


        },

        getItemArr(){
          let tempArr = this.getShuffledArr(this.teamData);
          return tempArr[0];
        },

        existsPast(obj){
          let ret = true;
          for(let i = 0; i < this.pastArr.length; i ++) {
            if(obj == this.pastArr[i]){
              ret = false;
            }
          }
          for(let i = 0; i < this.newArr.length; i ++) {
            if(obj == this.newArr[i]){
              ret = false;
            }
          }
          return ret;
        },

        getShuffledArr (arr){
          return [...arr].map( (_, i, arrCopy) => {
            var rand = i + ( Math.floor( Math.random() * (arrCopy.length - i) ) );
            [arrCopy[rand], arrCopy[i]] = [arrCopy[i], arrCopy[rand]]
            return arrCopy[i]
          })
        },


        clickItem(ev, n){

          this.vis = true;
        //  this.chars = 'chars' + this.newArr[n].text[this.lang].name.length;

          this.ballOpen = 'open';



          this.dragToolOff =  'hide';
          // let ballOff = window.innerHeight - $('.ball-text').offset().top;
          let ballOff =   $(ev.path[0]).offset().top - ($(ev.path[0]).height()/ 2);

          $("html, body").animate({ scrollTop: ballOff }, 600);
        },


        getRefWH(chars){

          let refCh = 0;
          let rePerc = 0;


          if(chars < 250){
            refCh = 231;
            rePerc = 90;
          }




          return { c:refCh , p : rePerc};

        }




        },
    };

</script>


// WEBPACK FOOTER //
// src/components/Modules/Team.vue